import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * As we use an existing SVG to power SYOS,
 * rather than rendering on the fly, this is
 * the one part of the App which diverges from
 * traditional React components, so most of the
 * behaviour here is done through manual DOM
 * manipulation and triggering custom events.
 *
 * This component just renders the HTML.
 * Most of the work happens in `SeatMapContainer`
 * and inside `behaviours/enhanceSeats`.
 */
class SeatMap extends Component {
  render() {
    let svgData = this.props.svgData;
    let facility = this.props.facility;

    let facilityNo = null;

    if (facility) {
      facilityNo = facility.facility_no;
    }

    let availability = false;
    svgData = svgData.replace(/<title>.*<\/title>/gi, '');

    /* eslint-disable react/no-danger */
    return svgData ? (
      <div
        ref={component => {
          this._seatmap = component;
          this._seatmapSvg = component && component.querySelector('svg');
          this._seats =
            component && component.querySelectorAll("#seatmap [id^='seat-']");
          this._levels =
            component && component.querySelectorAll('#seatmap > g');

          if (this._seatmapSvg && facilityNo) {
            this._seatmapSvg.id = `syos-facility-${facilityNo}`;
          }

          if (
            this._levels &&
            availability &&
            Object.keys(availability).length
          ) {
            this._levels.forEach((level, index) => {
              if (level.querySelector('.syos-level__availability')) {
                return;
              }

              const message = availability[level.id];

              if (!message) {
                return;
              }

              const levelBox = level.getBBox();

              const rectElement = document.createElementNS(
                'http://www.w3.org/2000/svg',
                'rect'
              );
              rectElement.setAttribute(
                'class',
                'syos-level__availability syos-level__availability--background'
              );
              rectElement.setAttribute('rx', 15);
              rectElement.setAttribute('ry', 15);
              rectElement.setAttribute('pointer-events', 'none');
              level.appendChild(rectElement);

              const textElement = document.createElementNS(
                'http://www.w3.org/2000/svg',
                'text'
              );
              textElement.setAttribute('font-size', 65);
              textElement.setAttribute('fill', '#fff');
              textElement.setAttribute('x', 0);
              textElement.setAttribute('y', 0);
              textElement.setAttribute(
                'class',
                'syos-level__availability syos-level__availability--text'
              );
              rectElement.setAttribute('pointer-events', 'none');
              textElement.textContent = message;
              level.appendChild(textElement);

              const textBox = textElement.getBBox();

              const textX = levelBox.x + levelBox.width / 2 - textBox.width / 2;
              const textY =
                levelBox.y +
                levelBox.height -
                textBox.height / 2 -
                350 * (index + 1);

              textElement.setAttribute('x', textX);
              textElement.setAttribute('y', textY);

              rectElement.setAttribute('x', textX - 50);
              rectElement.setAttribute('y', textY - 30);
              rectElement.setAttribute('width', textBox.width + 100);
              rectElement.setAttribute('height', textBox.height + 60);

              setTimeout(() => {
                level.removeChild(textElement);
                level.removeChild(rectElement);
              }, 7000);
            });
          }
        }}
        className={classnames({
          'syos-seatmap': true,
          'is-ready': this.props.isEnhanced
        })}
        dangerouslySetInnerHTML={{
          __html: svgData
        }}
      />
    ) : null;
  }
}
SeatMap.propTypes = {
  svgData: PropTypes.string,
  facility: PropTypes.object,
  isEnhanced: PropTypes.bool,
  availability: PropTypes.object
};

export default SeatMap;



// WEBPACK FOOTER //
// ./src/javascripts/app/components/SeatMap.js